// extracted by mini-css-extract-plugin
module.exports = {"image":"Content_image__3-GMb"};